var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7162 27.752L24.0762 22.628C23.9855 21.9022 23.6327 21.2346 23.0843 20.7506C22.5359 20.2667 21.8296 19.9997 21.0982 20H18.8942C18.1631 20.0002 17.4572 20.2674 16.9092 20.7513C16.3612 21.2352 16.0088 21.9026 15.9182 22.628L15.2772 27.752C15.242 28.0335 15.2671 28.3193 15.3508 28.5903C15.4346 28.8614 15.575 29.1116 15.7629 29.3242C15.9507 29.5368 16.1816 29.707 16.4403 29.8235C16.699 29.94 16.9795 30.0002 17.2632 30H22.7312C23.0148 30.0001 23.2952 29.9398 23.5537 29.8232C23.8123 29.7066 24.0431 29.5364 24.2308 29.3238C24.4185 29.1112 24.5589 28.8611 24.6425 28.5901C24.7262 28.3191 24.7513 28.0334 24.7162 27.752V27.752Z",
    stroke: "url(#paint0_linear_5055_29534)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16C21.6569 16 23 14.6569 23 13C23 11.3431 21.6569 10 20 10C18.3431 10 17 11.3431 17 13C17 14.6569 18.3431 16 20 16Z",
    stroke: "url(#paint1_linear_5055_29534)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C13.1046 19 14 18.1046 14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19Z",
    stroke: "url(#paint2_linear_5055_29534)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19C29.1046 19 30 18.1046 30 17C30 15.8954 29.1046 15 28 15C26.8954 15 26 15.8954 26 17C26 18.1046 26.8954 19 28 19Z",
    stroke: "url(#paint3_linear_5055_29534)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 22H11.6926C11.2192 21.9999 10.7611 22.1678 10.3998 22.4738C10.0385 22.7798 9.7975 23.204 9.71962 23.671L9.38662 25.671C9.33883 25.9575 9.35404 26.2511 9.43119 26.5311C9.50834 26.8112 9.64557 27.0711 9.83335 27.2928C10.0211 27.5144 10.2549 27.6925 10.5185 27.8146C10.7821 27.9368 11.0691 28 11.3596 28H14.9986M27.9986 22H28.3046C28.7781 21.9999 29.2362 22.1678 29.5974 22.4738C29.9587 22.7798 30.1997 23.204 30.2776 23.671L30.6106 25.671C30.6584 25.9575 30.6432 26.2511 30.5661 26.5311C30.4889 26.8112 30.3517 27.0711 30.1639 27.2928C29.9761 27.5144 29.7423 27.6925 29.4787 27.8146C29.2151 27.9368 28.9281 28 28.6376 28H24.9986",
    stroke: "url(#paint4_linear_5055_29534)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5055_29534",
    x1: -1.95711,
    y1: 5.46922,
    x2: 33.051,
    y2: -0.468897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5055_29534",
    x1: 6.09035,
    y1: 1.28154,
    x2: 28.1999,
    y2: -2.67866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5055_29534",
    x1: 2.7269,
    y1: 9.18769,
    x2: 17.4666,
    y2: 6.54756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5055_29534",
    x1: 18.7269,
    y1: 9.18769,
    x2: 33.4666,
    y2: 6.54756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5055_29534",
    x1: -29.3308,
    y1: 13.2815,
    x2: 28.3286,
    y2: -23.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c7b9251ec3edcc7eca5f1f8fa01ee794.svg";
export { ForwardRef as ReactComponent };